// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YaXs","colBig":"styles_colBig__mnpAu","colSmall":"styles_colSmall__8G7Wm"};